import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/l10n/pl';

document.addEventListener('DOMContentLoaded', function () {
        flatpickr(".datepicker", {
            dateFormat: 'd-m-Y',
            locale: 'pl',
        });
});